import { apiGet, registerLookup } from "@redriver/cinnamon";

const NAMESPACE = "FORMS/LOOKUPS";

const ActionTypes = {
  GetReturnOnInvestments: `${NAMESPACE}/GET_RETURN_ON_INVESTMENTS`,
};

export const LookupNames = {
  ReturnOnInvestments: "returnOnInvestmentsLookup",
};

export const getReturnOnInvestments = (params) =>
  apiGet(ActionTypes.GetReturnOnInvestments, `lookups/return-on-investments`, {
    ...params,
    excludeReturnOnInvestmentIds: params?.excludeReturnOnInvestmentIds || [],
    meteredServiceIds: params?.meteredServiceIds || [],
  });

registerLookup(LookupNames.ReturnOnInvestments, getReturnOnInvestments, {
  transform: (items) =>
    items.map((item) => ({
      ...item,
      id: item.value,
      name: item.text,
    })),
});
